import styled from 'styled-components'

export const StyledBuybackHistoryListContainer = styled.div`
  background: #ffffff;
  border-radius: 12px;
  margin-top: 35px;
  padding: 16px 32px 24px;

  .ant-table-cell {
    color: ${({ theme }) => theme.colors.textStrong};
    text-align: right;
    font-size: 17px;
    font-weight: 400;
    line-height: 20px;
    white-space: nowrap;

    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-left: 120px;
      padding-right: 0;
    }
  }

  .ant-table-placeholder {
    .ant-table-cell {
      &:first-child {
        padding-left: 16px;
      }
      &:last-child {
        padding-left: 16px;
        padding-right: 16px;
      }
    }
  }

  .ant-table-thead > tr > th {
    font-size: 14px;
    font-weight: 400;
    line-height: normal;
    color: ${({ theme }) => theme.colors.textTertiary};
    background: #ffffff;

    &:first-child,
    &:last-child {
      text-align: left;
    }
  }
  .ant-pagination-item:hover,
  .ant-pagination-item-active {
    border-color: ${({ theme }) => theme.colors.primary};
    a {
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  ${({ theme }) => theme.media.sm`
    margin-top: 16px;
    padding: 16px 24px;

    .ant-table-cell {
      font-size: 14px;

      &:last-child {
        padding-left: 16px;
      }
    }
  `}
`
export const StyledHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  padding-bottom: 18px;

  .left-part {
    font-size: 17px;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.textContent};
  }

  .right-part {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 2px 12px;
    border: 0.5px solid #e2e5f1;
    border-radius: 24px;

    .status-item {
      display: flex;
      align-items: center;
      gap: 2px;
      font-size: 13px;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.textSubtle};
    }
  }

  ${({ theme }) => theme.media.sm`
    gap: 8px;
    padding-bottom: 16px;

    .left-part {
      font-size: 15px;
    }

    .right-part {
      padding: 2px 4px;
      .status-item {
        font-size: 11px;
      }
    }
  `}
`

export const StyledTableDateItem = styled.div`
  color: #b9bed3;
  text-align: left;

  ${({ theme }) => theme.media.sm`
    width: 180px;
  `}
`

export const StyledTableBuyBackAmountItem = styled.div`
  color: ${({ theme }) => theme.colors.primary};
`

export const StyledTableStatusItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 10px;
  // @notice: Setting width in Table columns doesn't working correctly on iPhone, need to set content width here
  width: 102px;

  ${({ theme }) => theme.media.sm`
    padding: 0 3px;
  `}
`

export const StyledIcon = styled.img`
  width: 24px;
  height: 24px;

  ${({ theme }) => theme.media.sm`
    width: 18px;
    height: 18px;
  `}
`

export const StyledIconLink = styled.img`
  width: 16px;
  height: 24px;

  ${({ theme }) => theme.media.sm`
    width: 12px;
    height: 18px;
  `}
`

export const StyledHeaderIcon = styled.img`
  width: 18px;
  height: 18px;
`
